import {
  EvidenceFileTypeEnum,
  EvidenceMimeTypeEnum,
  UserImageFileTypeEnum,
  UserImageMimeTypeEnum,
} from "@s2z-platform/constants";

export function checkEvidenceFileName(value: string) {
  return (Object.keys(EvidenceFileTypeEnum) as EvidenceFileTypeEnum[]).some(
    (type) => value.toLowerCase().endsWith(`.${type}`),
  );
}

export function checkEvidenceMimeType(value: string) {
  return (Object.keys(EvidenceMimeTypeEnum) as EvidenceMimeTypeEnum[]).some(
    (acceptedMimeType) => value === acceptedMimeType,
  );
}

export function checkUserImageFileName(value: string) {
  return (Object.keys(UserImageFileTypeEnum) as UserImageFileTypeEnum[]).some(
    (type) => value.toLowerCase().endsWith(`.${type}`),
  );
}

export function checkUserImageMimeType(value: string) {
  return (Object.keys(UserImageMimeTypeEnum) as UserImageMimeTypeEnum[]).some(
    (acceptedMimeType) => value === acceptedMimeType,
  );
}

/**
 * Returns a URL- and S3-safe version of a user-supplied file name for use as an
 * object key segment.
 *
 * Reserved characters such as "+" and spaces break object retrieval once the
 * key is served over the CDN, and path separators would let a name escape its
 * key prefix. Only `[A-Za-z0-9._-]` is kept; any other run is replaced with a
 * single "-" and the extension is preserved. Lossy by design, so retain the
 * original name separately where it is needed for display.
 */
export function sanitizeFileName(fileName: string): string {
  // Drop directory components so only the final name remains.
  const baseName = fileName.split(/[/\\]/).pop() ?? "";

  const lastDotIndex = baseName.lastIndexOf(".");
  const hasExtension = lastDotIndex > 0;
  const rawStem = hasExtension ? baseName.slice(0, lastDotIndex) : baseName;
  const rawExtension = hasExtension ? baseName.slice(lastDotIndex + 1) : "";

  const clean = (value: string) =>
    value
      .replace(/[^A-Za-z0-9._-]+/g, "-")
      .replace(/-{2,}/g, "-")
      .replace(/^[-.]+|[-.]+$/g, "");

  const stem = clean(rawStem) || "file";
  const extension = clean(rawExtension);

  return extension ? `${stem}.${extension}` : stem;
}
